import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    patients: [],
    currentPatient: null,
    loading: false,
    error: null,
};

const sickleSlice = createSlice({
    name: 'sickle',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setPatients: (state, action) => {
            state.patients = action.payload;
        },
        setCurrentPatient: (state, action) => {
            state.currentPatient = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    },
});

export const { setLoading, setPatients, setCurrentPatient, setError, clearError } = sickleSlice.actions;
export default sickleSlice.reducer;